import androidx.compose.runtime.*
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.HTMLElement
import org.w3c.dom.events.Event
import org.w3c.dom.events.KeyboardEvent

@Composable
internal fun TourRoundStartDialog(slot: TourSlotDto, playerCount: Int, busy: Boolean, canConfirm: Boolean, error: String?, onCancel: () -> Unit, onConfirm: () -> Unit) {
    TourConfirmationDialog("tour-round-start-dialog", "Zahájení ${slot.roundNo}. rundy",
        "${slot.startsAt.take(5)} · Počet hráčů: $playerCount",
        "Potvrzením uložíte použité handicapy a uzamknete prezentaci, Jokera i rozlosování této rundy.",
        "Potvrdit zahájení rundy", "Zrušit zahájení", "Zahajuji…", busy, canConfirm, error, onCancel, onConfirm)
}

@Composable
internal fun TourRedrawDialog(slot: TourSlotDto, playerCount: Int, busy: Boolean, canConfirm: Boolean, error: String?, onCancel: () -> Unit, onConfirm: () -> Unit) {
    TourConfirmationDialog("tour-redraw-dialog", "Nové losování ${slot.roundNo}. rundy",
        "${slot.startsAt.take(5)} · Počet hráčů: $playerCount",
        "Stávající rozlosování nahradíte novým losem podle aktuálního obsazení rundy.",
        "Potvrdit nové losování", "Zrušit losování", "Losuji…", busy, canConfirm, error, onCancel, onConfirm)
}

@Composable
private fun TourConfirmationDialog(dialogId: String, title: String, subtitle: String, description: String,
    confirmLabel: String, cancelLabel: String, busyLabel: String, busy: Boolean, canConfirm: Boolean,
    error: String?, onCancel: () -> Unit, onConfirm: () -> Unit) {
    val currentBusy by rememberUpdatedState(busy)
    val cancel by rememberUpdatedState(onCancel)
    DisposableEffect(dialogId) {
        val previous = document.activeElement as? HTMLElement
        val overflow = document.body?.style?.getPropertyValue("overflow").orEmpty()
        document.body?.style?.setProperty("overflow", "hidden")
        val listener: (Event) -> Unit = { event ->
            val key = event as? KeyboardEvent
            if (key?.key == "Escape") { key.preventDefault(); if (!currentBusy) cancel() }
            if (key?.key == "Tab") {
                val buttons = document.getElementById(dialogId)?.querySelectorAll("button:not(:disabled)")
                val first = buttons?.item(0) as? HTMLElement
                val last = buttons?.item((buttons.length - 1).coerceAtLeast(0)) as? HTMLElement
                if (first == null) key.preventDefault()
                else if (key.shiftKey && document.activeElement == first) { key.preventDefault(); last?.focus() }
                else if (!key.shiftKey && document.activeElement == last) { key.preventDefault(); first.focus() }
            }
        }
        window.addEventListener("keydown", listener)
        onDispose {
            window.removeEventListener("keydown", listener)
            document.body?.style?.setProperty("overflow", overflow)
            if (previous?.isConnected == true) previous.focus()
        }
    }
    LaunchedEffect(dialogId) { (document.getElementById("$dialogId-cancel") as? HTMLElement)?.focus() }
    Div(attrs = { classes("modal-backdrop"); onClick { if (!busy) onCancel() } }) {
        Div(attrs = {
            classes("match-modal", "tour-confirm-modal"); id(dialogId)
            attr("role", "dialog"); attr("aria-modal", "true"); attr("aria-labelledby", "$dialogId-title"); attr("aria-describedby", "$dialogId-description")
            onClick { it.stopPropagation() }
        }) {
            H2(attrs = { id("$dialogId-title") }) { Text(title) }
            P(attrs = { classes("muted") }) { Text(subtitle) }
            P(attrs = { id("$dialogId-description") }) { Text(description) }
            TourError(error)
            Div(attrs = { classes("tour-actions") }) {
                Button(attrs = { classes("primary"); type(ButtonType.Button); if (busy || !canConfirm) disabled(); onClick { onConfirm() } }) { Text(if (busy) busyLabel else confirmLabel) }
                Button(attrs = { id("$dialogId-cancel"); type(ButtonType.Button); if (busy) disabled(); onClick { onCancel() } }) { Text(cancelLabel) }
            }
        }
    }
}
